/**
 * Determines whether the Release Notes Button should be displayed.
 * @param {object} params
 * @param {boolean} params.releaseNotesEnabled - Whether release notes are enabled
 * @param {boolean} params.isWithinDisplayPeriod - Whether current time is within display period
 * @param {string|null} params.releaseNotesUrl - Release notes URL
 * @param {boolean} params.isIssueValidationOnlyUser - Whether user is Issue Validation Only
 * @param {boolean} params.hasSettings - Whether settings have been loaded
 * @returns {boolean} Whether to show the button
 */
export const shouldShowReleaseNotesButton = ({
  releaseNotesEnabled,
  isWithinDisplayPeriod,
  releaseNotesUrl,
  isIssueValidationOnlyUser,
  hasSettings,
}) => {
  if (!hasSettings) return false;
  if (isIssueValidationOnlyUser) return false;
  if (!releaseNotesEnabled) return false;
  if (!isWithinDisplayPeriod) return false;
  if (!releaseNotesUrl || !releaseNotesUrl.trim()) return false;
  return true;
};

/**
 * Determines whether the Feedback Button should be displayed.
 * @param {object} params
 * @param {boolean} params.feedbackEnabled - Whether feedback is enabled
 * @param {string|null} params.feedbackUrl - Feedback URL
 * @param {boolean} params.isIssueValidationOnlyUser - Whether user is Issue Validation Only
 * @param {boolean} params.hasSettings - Whether settings have been loaded
 * @returns {boolean} Whether to show the button
 */
export const shouldShowFeedbackButton = ({
  feedbackEnabled,
  feedbackUrl,
  isIssueValidationOnlyUser,
  hasSettings,
}) => {
  if (!hasSettings) return false;
  if (isIssueValidationOnlyUser) return false;
  if (!feedbackEnabled) return false;
  if (!feedbackUrl || !feedbackUrl.trim()) return false;
  return true;
};

/**
 * Gets the display label for the Feedback Button.
 * @param {string|null|undefined} feedbackLabel - Label retrieved from settings
 * @returns {string} The label string to display
 */
export const getFeedbackLabel = (feedbackLabel) => {
  if (!feedbackLabel || !feedbackLabel.trim()) return "Feedback";
  return feedbackLabel;
};
